const data = {
    city: "Ibagué, Tolima",
    phone: "+57 320 253 4042",
    email: "santiagopc333@gmail.com",
    birthdate: "07/03/2007",
    id: "C.C. 1070730214",
    github: "https://github.com/yuber-paez",
}

export default data;